export default __webpack_public_path__ + "static/media/walletconnect.aa6c9f2b.svg";